// extracted by mini-css-extract-plugin
module.exports = {"seoCopyDescriptionContainer":"az_Ahb"};